import React, {useEffect, useState} from 'react'
import classes from './laborantForm.module.scss'
import Form from '../../../Forms/EnterForm'
import {useDispatch, useSelector} from "react-redux";
import {expressCreation, gistologyCreation} from '../../../../store/reducers/LaborantReducer/LaborantReducer';
import {useNavigate} from 'react-router-dom';
import {ClearInputs} from "../../../../store/reducers/ScanReducer/RegistrationScanReducer";
import { laborantService } from '../../../../api/laborantService'
import { DoctorService } from '../../../../api/DoctorService'
import { toast } from 'react-toastify';

const LaborantForm = (numbers) => {
    const navigate = useNavigate()
    const [printed, setPrinted] = useState(false)
    const [formValue, setFormValue] = useState()
    const [renderForm, setRenderForm] = useState(false)

    const [laborantCard, setLaborantCard] = useState({
        'description': '',
        'cassettes': [],
        'archive': '',
        'calcium': '',
        'doc': '',
        'laborant': ''
    })
    let type
    const dispatch = useDispatch()
    const form = useSelector(state => state.RegScan.ScanInputs)

    if (form.research === 'Гістологія'){
        type = 'Gistology'
    } else if (form.research === 'Експрес'){
        type = 'Express'
    }


    const values = useSelector(state => state.labForm)

    const getOptions = async() =>{
        await DoctorService.getAllWorkersByRole().then(res=>{
          if(res?.data){
            value.fields.map(async(element)=>{
              if(element.legend == 'Лікар'){
                res?.data.doctor.map(docs=>{
                  let obj = {
                    "value": docs.name,
                    "label": docs.name,
                    "id":docs.id,
                    "type": 'option'
                  }
                doc.push(obj)
                })
              } else if (element.legend == 'Лаборант'){
                res?.data.laboratoryAssistant.map(labor=>{
                  let obj = {
                      "value": labor.name,
                      "label": labor.name,
                      "id":labor.id,
                      "type": 'option'
                  }
                  lab.push(obj)
                })
              }
            })
          } 
        })
      }

    let value = '1'
    let doc = []
    let lab = []

    values.map((el)=>{
        if (el.formType === type){
          if (type === 'Gistology'){
            value = el
          } else if (type === 'Express'){
            value = el
          }
        }
    })

    const handleLaborant = (data) => {
        if (type === 'Gistology'){
            let arr = []
            for(let key in data){
                if (key.includes('casset')){
                    arr.push(data[key]);
                }
            }
            setLaborantCard({
                'doctorId': data.doc.id,
                'laboratoryAssistantId': data.laborant.id,
                'data': {
                    'description': data.description,
                    'cassettes': arr,
                    'archive': data.archive,
                    'calcium': data.calcium,
                }
            })
        } else {
            setLaborantCard({
                'data': {
                    'description': data.description
                },
                'doctorId': data.doc.id,
                'laboratoryAssistantId': data.laborant.id
            })
        }
    }

    const updateHandler = async(id, formOuput) => {
        await laborantService.updateLabForm(id, {data: formOuput.data, doctorId: formOuput.doctorId, laboratoryAssistantId: formOuput.laboratoryAssistantId}).then(res=>{
          if (res) toast.done('Форма успішно заповнена')
        })
        await laborantService.updateStatusDirection(id, {status: 'scanAfterForm'}).then(res=>{
          if (res)  toast.info('Статус скерування оновлено')
        })
    }

    useEffect(() => {
        let id = form.id
        if (laborantCard.doc !== ''){
            if (type === 'Gistology'){
                dispatch(gistologyCreation({credential: laborantCard}))
                updateHandler(id,laborantCard)
                if (printed){
                    dispatch(ClearInputs())
                    navigate("/ScanPage")
                } else {
                    toast.error('Роздрукуйте наліпки перед збереженням')
                }
            } else if (type === 'Express'){
                dispatch(expressCreation({credential: laborantCard}))
                updateHandler(id,laborantCard)
                if (printed){
                    dispatch(ClearInputs())
                    navigate("/ScanPage")
                } else {
                    toast.error('Роздрукуйте наліпки перед збереженням')
                }
            }
        }
    }, [laborantCard])

    const onPrinted = () => {
        setPrinted(true)
    }

    useEffect(()=>{
        if(value !== '1'){
            getOptions()
            setFormValue(value)
            setFormValue(state=>({
                ...state,
                fields: state?.fields?.map((item)=>{
                    let option;
                    if (item.name == 'doc') {
                        option = doc;
                    }
                    if (item.name == 'laborant'){
                        option = lab
                    }

                    return option 
                    ? {
                        ...item,
                        props: option
                    }
                    : {...item};
                })
            }))
            setRenderForm(true)
        }
    },[value])


    useEffect(()=>{
        if(form.id ==  ""){
            navigate('/ScanPage')
        }
    },[form])

    return (
        <div className={classes.laborantForm}>
           {renderForm && <Form quant={form.quantityMaterial} id={form.id} onChange={handleLaborant} values={formValue} onPrinted={onPrinted} />}
        </div>
    )
}

export default LaborantForm